module.exports = __webpack_public_path__ + "static/media/sorry@3x.0c9fba52.png";